import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const DebrisCloudAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 0; i < 60; i++) {
    const a = Math.random() * Math.PI * 2;
    const rBase = e.maxRadius + Math.random() * 150 * progress;
    const r = getRadiusAtAngle(a, e, rBase);
    const drift = progress * 150;
    ctx.beginPath(); ctx.arc(e.pos.x + Math.cos(a) * r, e.pos.y + Math.sin(a) * r + drift, 3, 0, Math.PI * 2); ctx.fill();
  }
};

registerBlastAnimation('DEBRIS_CLOUD', DebrisCloudAnimation);
